import {
  HashRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import ModalContainer from "./components/containers/ModalContainer";
import ToastContainer from "./components/containers/ToastContainer";
import RootGuard from "./components/guards/RootGuard";
import RootLayout from "./components/layouts/Root";
import useCurrentRoutes from "./hooks/useCurrentRoutes";
import { useTypedSelector } from "./store/store";
import { getLayoutChrome } from "./utils/constants/layoutChrome";
import { ROOT, SIGN_IN } from "./utils/constants/routes";

function Navigation() {
  const { brand } = useTypedSelector((state) => state.environment);
  const { sessionKey } = useTypedSelector((state) => state.session);

  const { routes } = useCurrentRoutes();

  return (
    <div style={{ minHeight: "100vh" }}>
      <RootGuard>
        <Router>
          <ModalContainer>
            <Routes>
              {Object.entries(routes).map(([routeKey, route]) => {
                const { element: Element, layout } = route;

                const chrome = getLayoutChrome(routeKey, brand);

                return (
                  <Route
                    key={routeKey}
                    path={routeKey}
                    element={
                      <RootLayout
                        type={layout}
                        showHeader={chrome.showHeader}
                        showFooter={chrome.showFooter}>
                        <Element />
                      </RootLayout>
                    }
                  />
                );
              })}

              <Route
                path="*"
                element={<Navigate to={sessionKey ? ROOT : SIGN_IN} />}
              />
            </Routes>
          </ModalContainer>
        </Router>
      </RootGuard>

      <ToastContainer />
    </div>
  );
}

export default Navigation;
